import { Injectable, inject } from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {PrestatieService} from '../prestatie/prestatie.service';

@Injectable({
  providedIn: 'root'
})
export class ActievePrestatieGuard {
  private prestatieService = inject(PrestatieService);
  private router = inject(Router);

  private canActivate(): Observable<boolean | UrlTree> {
    return this.prestatieService.getActievePrestatie$()
      .pipe(
        map(prestatie => !!prestatie ? true : this.router.parseUrl('/prestatie/start')),
      );
  }
}
